import React, { useState } from "react";
import { useGetMyRentCorpQuery } from "@/redux/rentCorpApi";

export const RentCorpSelectionTable = ({ onSelect, selectedRentCorp }) => {
    // 사업자 리스트 조회
    const { data: myRentCorpData, isLoading } = useGetMyRentCorpQuery();

    const handleRentCorpSelect = (rentCorp) => {
        onSelect(rentCorp);
    };

    if (isLoading) {
        return (
            <div className="rent-corp-table-group">
                <label>청구 대상 사업자</label>
                <div className="table-container">
                    <div className="table-content">
                        <div className="cell" data-align="center">
                            <span className="cell-desc">로딩 중...</span>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div className="rent-corp-table-group">
            <label>청구 대상 사업자</label>
            <div className="table-container">
                <div className="table-content">
                    <div className="table-wrapper">
                        <div className="table">
                            <table>
                                <colgroup>
                                    <col width="8%" />
                                    <col width="20%" />
                                    <col width="18%" />
                                    <col width="18%" />
                                    <col width="18%" />
                                    <col width="18%" />
                                </colgroup>
                                <thead>
                                    <tr>
                                        <th>
                                            <div className="cell">
                                                <div className="cell-tit">선택</div>
                                            </div>
                                        </th>
                                        <th>
                                            <div className="cell">
                                                <div className="cell-tit">업체명</div>
                                            </div>
                                        </th>
                                        <th>
                                            <div className="cell">
                                                <div className="cell-tit">사업자번호</div>
                                            </div>
                                        </th>
                                        <th>
                                            <div className="cell">
                                                <div className="cell-tit">은행명</div>
                                            </div>
                                        </th>
                                        <th>
                                            <div className="cell">
                                                <div className="cell-tit">예금주</div>
                                            </div>
                                        </th>
                                        <th>
                                            <div className="cell">
                                                <div className="cell-tit">계좌번호</div>
                                            </div>
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {myRentCorpData && myRentCorpData.data && myRentCorpData.data.length > 0 ? (
                                        myRentCorpData.data.map((rentCorp) => (
                                            <tr key={rentCorp.id}>
                                                <td>
                                                    <div className="cell" style={{ height: "100%" }}>
                                                        <div className="input-checkbox">
                                                            <div className="checkbox" style={{ display: "flex" }}>
                                                                <input
                                                                    type="radio"
                                                                    name="selectedRentCorp"
                                                                    id={`selectedRentCorp-${rentCorp.id}`}
                                                                    checked={selectedRentCorp?.id === rentCorp.id}
                                                                    onChange={() => handleRentCorpSelect(rentCorp)}
                                                                />
                                                                <label htmlFor={`selectedRentCorp-${rentCorp.id}`}></label>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </td>
                                                <td>
                                                    <div className="cell">
                                                        <div className="cell-desc">{rentCorp.corpName}</div>
                                                    </div>
                                                </td>
                                                <td>
                                                    <div className="cell">
                                                        <div className="cell-desc">{rentCorp.corpNumber}</div>
                                                    </div>
                                                </td>
                                                <td>
                                                    <div className="cell">
                                                        <div className="cell-desc">{rentCorp.bankName}</div>
                                                    </div>
                                                </td>
                                                <td>
                                                    <div className="cell">
                                                        <div className="cell-desc">{rentCorp.bankOwner}</div>
                                                    </div>
                                                </td>
                                                <td>
                                                    <div className="cell">
                                                        <div className="cell-desc">{rentCorp.bankAccount}</div>
                                                    </div>
                                                </td>
                                            </tr>
                                        ))
                                    ) : (
                                        <tr>
                                            <td colSpan="6" className="data-empty">
                                                <div className="cell" data-align="center">
                                                    <span className="cell-desc">사업자 데이터가 없습니다.</span>
                                                </div>
                                            </td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};
